/*
 * Royal Luxury Creams – kleine Helfer für die RLC-Sektionen:
 * 1. "In den Warenkorb"-Knöpfe ([data-rlc-add]) legen über die Shopify-Cart-API
 *    in den Warenkorb und melden das Horizon, damit die Warenkorb-Schublade
 *    sich aktualisiert und öffnet.
 * 2. Produktgalerie: Pfeile und Vorschaubilder.
 * 3. Mobile Kaufleiste: sichtbar, solange der Haupt-Knopf nicht im Bild ist.
 */
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

async function loadEvents() {
  try { return await import('@shopify/events'); } catch { return null; }
}

async function addToCart(button) {
  const id = Number(button.dataset.rlcAdd);
  if (!id || button.getAttribute('aria-busy') === 'true') return;
  button.setAttribute('aria-busy', 'true');
  const events = await loadEvents();
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId).filter(Boolean);
  let deferred = null;
  try {
    if (events && events.CartLinesUpdateEvent) {
      deferred = events.CartLinesUpdateEvent.createPromise();
      button.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise,
      }));
    }
  } catch { deferred = null; }
  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    const cartRes = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await cartRes.json();
    if (!res.ok || data.status) {
      deferred?.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'rlc', sourceId: 'rlc' } });
      if (!deferred) alert(data.description || data.message || 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.');
      return;
    }
    if (deferred) {
      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'rlc', sourceId: 'rlc', itemCount: 1, productId: String(data.items?.[0]?.product_id ?? ''), sections: data.sections, didError: false },
      });
      // Ohne Schublade (z. B. Warenkorb als Seite eingestellt) direkt zum Warenkorb
      if (!document.querySelector('cart-drawer-component')) window.location.href = `${root}cart`;
    } else {
      window.location.href = `${root}cart`;
    }
  } catch (error) {
    deferred?.reject?.(error);
    window.location.href = `${root}cart`;
  } finally {
    button.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-rlc-add]') : null;
  if (!button) return;
  event.preventDefault();
  addToCart(button);
});

// Galerie
for (const gallery of document.querySelectorAll('[data-rlc-gallery]')) {
  const track = gallery.querySelector('[data-rlc-track]');
  const slides = [...gallery.querySelectorAll('.rlc-gallery-slide')];
  const prev = gallery.querySelector('[data-rlc-prev]');
  const next = gallery.querySelector('[data-rlc-next]');
  const thumbs = [...gallery.querySelectorAll('[data-rlc-thumb]')];
  if (!track || slides.length === 0) continue;
  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  const goTo = (i) => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
  };
  const sync = () => {
    const i = current();
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= slides.length - 1;
    for (const t of thumbs) {
      const on = Number(t.dataset.rlcThumb) === i;
      t.setAttribute('aria-current', String(on));
      t.classList.toggle('border-espresso', on);
      t.classList.toggle('border-sand/80', !on);
      t.classList.toggle('hover:border-champagne', !on);
    }
  };
  prev?.addEventListener('click', () => goTo(current() - 1));
  next?.addEventListener('click', () => goTo(current() + 1));
  for (const t of thumbs) t.addEventListener('click', () => goTo(Number(t.dataset.rlcThumb)));
  track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
  window.addEventListener('resize', sync);
  sync();
}

// Mobile Kaufleiste
const bar = document.querySelector('[data-rlc-sticky]');
const anchor = document.querySelector('#kaufen [data-rlc-add], #kaufen button');
if (bar) {
  const publish = () => document.documentElement.style.setProperty('--kaufleiste-hoehe', `${bar.offsetHeight}px`);
  publish();
  new ResizeObserver(publish).observe(bar);
  const setVisible = (visible) => {
    bar.classList.toggle('translate-y-full', !visible);
    bar.classList.toggle('translate-y-0', visible);
    bar.setAttribute('aria-hidden', String(!visible));
    bar.querySelector('button')?.setAttribute('tabindex', visible ? '0' : '-1');
  };
  if (anchor) {
    new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), { threshold: 0 }).observe(anchor);
  } else {
    setVisible(true);
  }
}
